import { useEffect, useState } from "react";
import { ComposableMap, Geographies, Geography } from "react-simple-maps";

const GEO_URL = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";

/**
 * Low-opacity US map for hero backgrounds. Highlights the viewer's home state
 * when `highlight` (state name, e.g. "Texas") is provided.
 * Purely decorative — pointer-events disabled.
 */
export default function HeroMapBackground({ className = "", highlight = null }) {
    const [ready, setReady] = useState(false);
    useEffect(() => { setReady(true); }, []);

    if (!ready) return null;

    return (
        <div className={`absolute inset-0 flex items-center justify-center pointer-events-none ${className}`} data-testid="hero-map-bg">
            <ComposableMap projection="geoAlbersUsa" width={1400} height={800} style={{ width: "120%", height: "auto", maxWidth: "1600px" }}>
                <Geographies geography={GEO_URL}>
                    {({ geographies }) =>
                        geographies.map(geo => {
                            const name = geo.properties.name;
                            const isHome = highlight && name === highlight;
                            return (
                                <Geography
                                    key={geo.rsmKey}
                                    geography={geo}
                                    style={{
                                        default: {
                                            fill: isHome ? "rgba(168, 85, 247, 0.55)" : "rgba(168, 85, 247, 0.10)",
                                            stroke: isHome ? "#C084FC" : "rgba(255,255,255,0.22)",
                                            strokeWidth: isHome ? 1.8 : 0.6,
                                            outline: "none",
                                            filter: isHome ? "drop-shadow(0 0 26px rgba(168, 85, 247, 0.85)) drop-shadow(0 0 10px rgba(168, 85, 247, 0.6))" : "none",
                                        },
                                        hover: { outline: "none" },
                                        pressed: { outline: "none" },
                                    }}
                                />
                            );
                        })
                    }
                </Geographies>
            </ComposableMap>
        </div>
    );
}
